export const MOUNT_NODE_ID = 'main';
